import type { SimilarDesignsRepository } from '../../domain/interfaces/SimilarDesignsRepository';

export type SimilarDesignsService = ReturnType<typeof createSimilarDesignsService>;

export function createSimilarDesignsService(repo: SimilarDesignsRepository) {
  return {
    getSimilarDesigns(designId: string) {
      return repo.fetchSimilarDesigns(designId);
    },
  };
}
